module.exports = __webpack_public_path__ + "img/retired-2014-canal.4d041336.jpg";